import { Component, OnInit } from "@angular/core";
import { GalleryGroupsSiteService } from "src/app/services/galleryGroupsSite.service";
import { ProductTypesSiteService } from "src/app/services/productTypesSite.service";
import { GalleryGroupGetListOutputDTO } from "src/app/models/informations.models/galleryGroup.models/galleryGroupGetListOutputDTO.model";
import { DResult } from "src/app/models/common.models/dresult.model";
import { DynamicPagesSiteService } from "src/app/services/dynamicPagesSite.service";
import { DynamicPageGetListOutputDTO } from "src/app/models/contents.models/DynamicPage.models/DynamicPageGetListOutputDTO.model";
import { PageRootMenuViewModel } from 'src/app/models/common.models/pageRootMenuViewModel.model';
import { PageSubMenuViewModel } from 'src/app/models/common.models/pageSubMenuViewModel.model';

@Component({
  selector: "sitenavbar",
  templateUrl: "sitenavbar.component.html"
})
export class SiteNavBarComponent implements OnInit {
  ngOnInit(): void {
    this.GetGalleryGroups();
    this.GetMenuGroups();
    this.GetDynamicPages();
  }

  galleryGroupItems: GalleryGroupGetListOutputDTO[] = [];
  menuGroupItems: GalleryGroupGetListOutputDTO[] = [];
  dynamicPagesItems: DynamicPageGetListOutputDTO[] = [];
  pageRootMenuViewModelArray: PageRootMenuViewModel[] = [];

  constructor(
    private galleryGroupsSiteService: GalleryGroupsSiteService,
    private productTypesSiteService: ProductTypesSiteService,
    private dynamicPagesSiteService: DynamicPagesSiteService
  ) {}

  GetGalleryGroups() {
    this.galleryGroupsSiteService
      .GetList()
      .subscribe((data: DResult<GalleryGroupGetListOutputDTO[]>) => {
        if (data.isSuccess) {
          this.galleryGroupItems = data.result;
        }
      });
  }
  GetMenuGroups() {
    this.productTypesSiteService
      .GetList()
      .subscribe((data: DResult<GalleryGroupGetListOutputDTO[]>) => {
        if (data.isSuccess) {
          this.menuGroupItems = data.result;
        }
      });
  }
  GetDynamicPages() {
    this.dynamicPagesSiteService
      .GetList()
      .subscribe((data: DResult<DynamicPageGetListOutputDTO[]>) => {
        if (data.isSuccess) {
          this.dynamicPagesItems = data.result;

          this.ProcessMenu();
        }
      });
  }

  ProcessMenu() {
    let rootPageArray = this.dynamicPagesItems.filter(p => p.parentId === 0);
    rootPageArray.forEach(element => {
      let rootObj = new PageRootMenuViewModel();
      rootObj.id = element.id;
      rootObj.title = element.title;

      let subItems = this.dynamicPagesItems.filter(p => p.parentId === element.id);
      if (subItems.length > 0) {
        rootObj.hasSubMenu = true;
        subItems.forEach(subElement => {
          let subObj = new PageSubMenuViewModel();
          subObj.id = subElement.id;
          subObj.title = subElement.title;

          rootObj.PageSubMenuViewModelArray.push(subObj);
        })
      }

      this.pageRootMenuViewModelArray.push(rootObj);
    });
  }
}
